import { Document } from '@contentful/rich-text-types'
import * as contentful from 'contentful'
import { Entry } from 'contentful'
import { useEffect, useState } from 'react'
import Entries from '../config/entries'
import entriesMapping from '../config/entries-mapping'
import Screens from '../config/screens'
import screenNameMapping from '../config/screens-mapping'
import { environmentVariables } from '../environment-variables'

const client = contentful.createClient({
  space: environmentVariables.REACT_APP_CONTENTFUL_SPACE_ID,
  environment: environmentVariables.REACT_APP_CONTENTFUL_ENVIRONMENT, // defaults to 'master' if not set
  accessToken: environmentVariables.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
})

interface Fields {
  richText?: Document
  richTextLinksOnly?: Document
  bannerTitle?: string
  bannerBody?: Document
}

// Takes a screen and fetches all content for that screen from contentful
function useContentful(screen: Screens) {
  const [isLoading, setIsLoading] = useState(true)

  const [items, setItems] = useState<{ [key in Entries]?: Entry<Fields> }>({})

  useEffect(() => {
    client
      .getEntries<Fields>({
        'metadata.tags.sys.id[in]': screenNameMapping[screen].screenTagId,
      })
      .then((entries) => {
        // wrangle the contentful response into developer friendly object.
        let initialEntries: { [key in Entries]?: Entry<Fields> } = {}
        initialEntries = entries.items.reduce((accumulator, entry) => {
          screenNameMapping[screen].entries.forEach((entryId) => {
            entry.metadata.tags.forEach((tagLink) => {
              if (tagLink.sys.id === entriesMapping[entryId]) {
                if (!accumulator[entryId]) {
                  accumulator[entryId] = entry
                }
              }
            })
          })
          return accumulator
        }, initialEntries)
        setItems(initialEntries)
        setIsLoading(false)
      })
      .catch(console.error)
  }, [screen])

  return { items, isLoading }
}

export default useContentful
